// Turnstile Site key (공개값). 빌드 시 VITE_TURNSTILE_SITE_KEY 로 주입.
// 값이 없으면 위젯을 렌더하지 않고 로그인은 그대로 동작(점진 적용).
const env = import.meta.env as unknown as Record<string, string | undefined>;

export const TURNSTILE_SITE_KEY = env.VITE_TURNSTILE_SITE_KEY ?? '';

export interface TurnstileApi {
  render(
    el: HTMLElement,
    opts: {
      sitekey: string;
      callback: (token: string) => void;
      'error-callback'?: () => void;
      'expired-callback'?: () => void;
      theme?: 'auto' | 'light' | 'dark';
    },
  ): string;
  reset(widgetId?: string): void;
}

declare global {
  interface Window {
    turnstile?: TurnstileApi;
  }
}
